module.exports = __webpack_public_path__ + "img/details-background.25e9c321.png";